export interface RequestedFormCompletion {
  created_at: string;
  description: string;
  form_answer_group_healthie_id: string | null;
  form_answer_group_id: string | null;
  icon: string;
  healthie_id: number;
  id: string;
  name: string;
  requested_by_id: string;
  requested_by_name: string;
  signed_at: string | null;
  status: DocumentStatus;
}

export enum DocumentStatus {
  Incomplete = 'Incomplete',
  Open = 'Open',
  Finished = 'Finished'
}
